<template>
  <b-row>
    <b-col>
      <b-row
        class="m-3"
        align-v="center"
      >
        <b-col md="12">
          <h2
            class="text-center"
            style="color:#44a676;"
          >Directorio</h2>
          <hr>
        </b-col>
      </b-row>
      <b-row
        class="m-md-3 m-lg-3"
        align-v="center"
      >
        <b-col md="6">
          <div
            class="accordion"
            role="tablist"
          >
            <b-card
              no-body
              class="mb-1"
            >
              <b-card-header
                header-tag="header"
                class="p-1"
                role="tab"
              >
                <b-button
                  v-b-toggle.accordion-1
                  variant="outline"
                  size="lg"
                >Información inscripciones
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <p><feather-icon
                    icon="SmartphoneIcon"
                    size="21"
                    class="text-success stroke-current"
                  /> 3336695550 al 5559 ext: 960 y ext: 310</p>
                  <p><feather-icon
                    icon="MailIcon"
                    size="21"
                    class="text-success stroke-current"
                  /> {{ mailConstructor(2) }}</p>
                  <p><b>Horario de atención telefónica</b></p>
                  <p><feather-icon
                    icon="ClockIcon"
                    size="21"
                    class="text-success stroke-current"
                  /> 8:30 am - 4:00 pm</p> <p>Lunes - Viernes</p>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div></b-col>
        <b-col md="6">
          <b-img
            :src="`${delivery}publico/paginas/contacto/contacto-indetec-campus-virtual.jpg`"
            fluid-grow
            alt="Contacto indetec campus virtual"
            style="width:70% !important"
            rounded
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BImg, VBToggle, BButton, BCollapse, BCard, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import 'leaflet/dist/leaflet.css'
import { mailConstructor } from '@core/utils/utils'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BButton,
    BCollapse,
    BCard,
    BCardHeader,
    BCardBody,
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  data() {
    return {
      mailConstructor,
    }
  },
  setup() {
    const delivery = process.env.VUE_APP_DELIVERY_DOWNLOAD
    return {
      delivery,
    }
  },
}
</script>
<style lang="scss">
.card {
    background-color: #f8f8f8;
}
</style>
